import { createSlice } from "@reduxjs/toolkit";
import { recetNewService, recetExistService } from "@/utils/constants";

import { ISliceService } from "@/shared/interfaces/service";

const initialState: ISliceService = {
    isEditService: false,
    selectedServiceId: "",
    newServiceData: recetNewService,
    existService: recetExistService,
    serviceData: [],
    dataLength: 0,
    category: "all",
};

const serviceSlice = createSlice({
    name: "services",
    initialState,
    reducers: {
        setServiseData: (state, action) => {
            state.serviceData = action.payload;
            state.dataLength = action.payload.length;
        },
        updateNewService: (state, action) => {
            state.newServiceData = action.payload;
        },
        updateExistService: (state, action) => {
            state.existService = { ...action.payload };
        },
        resetExistService: state => {
            state.existService = recetExistService;
            state.selectedServiceId = "";
            state.isEditService = false;
        },
        setSelectedService: (state, action) => {
            state.isEditService = true;
            state.selectedServiceId = action.payload;
            const selectedService = state.serviceData.find(
                item => item._id === action.payload,
            );
            state.existService = selectedService || recetExistService;
        },
        deleteService: (state, action) => {
            const newArr = state.serviceData.filter(
                item => item._id !== action.payload,
            );
            state.serviceData = [...newArr];
            state.dataLength = newArr.length;
            state.selectedServiceId = "";
        },
        addNewService: (state, action) => {
            const newData = [action.payload, ...state.serviceData];
            state.serviceData = newData;
            state.dataLength = newData.length;
        },
        updateService: (state, action) => {
            const newData = state.serviceData.map(item =>
                item._id === state.selectedServiceId
                    ? { ...item, ...action.payload }
                    : item,
            );
            state.serviceData = newData;
        },
    },
});

export const {
    updateNewService,
    updateExistService,
    resetExistService,
    setSelectedService,
    deleteService,
    setServiseData,
    addNewService,
    updateService,
} = serviceSlice.actions;
export default serviceSlice.reducer;
